import { v4 as uuidv4 } from 'uuid';
import { safeLocalStorage } from '@/utils/safeStorage';

const CHANNEL_NAME = 'studio-login';
const STORAGE_KEY = 'studio-login-event';
const source = uuidv4();

export function broadcastLogin() {
  const message = { type: 'login', source, id: uuidv4() };
  try {
    const channel = new window.BroadcastChannel(CHANNEL_NAME);
    channel.postMessage(message);
    channel.close();
    return;
  } catch {
    try {
      safeLocalStorage.setItem(STORAGE_KEY, JSON.stringify(message));
    } catch {
      return;
    }
  }
}

export function listenForLogin(onLogin) {
  let channel;
  const receive = (message) => {
    if (message?.type === 'login' && message.source && message.source !== source) {
      onLogin();
    }
  };
  const handleStorage = (event) => {
    if (event.key !== STORAGE_KEY || !event.newValue) return;
    try {
      receive(JSON.parse(event.newValue));
    } catch {
      return;
    }
  };

  try {
    channel = new window.BroadcastChannel(CHANNEL_NAME);
    channel.onmessage = (event) => receive(event.data);
  } catch {
    channel = null;
  }
  window.addEventListener('storage', handleStorage);

  return () => {
    if (channel) channel.close();
    window.removeEventListener('storage', handleStorage);
  };
}